const pageNameKey = "alarmProfileEmailRecipientsList";

export const alarmProfileEmailRecipientsListEn = {
  [pageNameKey]: {
    altText: "Recipient",
  },
};

export const alarmProfileEmailRecipientsListPtBr = {
  [pageNameKey]: {
    altText: "Destinatário",
  },
};

export const alarmProfileEmailRecipientsListDe = {
  [pageNameKey]: {
    altText: "Empfänger",
  },
};

export const alarmProfileEmailRecipientsListZhHans = {
  [pageNameKey]: {
    altText: "收件人",
  },
};

export const alarmProfileEmailRecipientsListIt = {
  [pageNameKey]: {
    altText: "Destinatario",
  },
};

export const alarmProfileEmailRecipientsListEs = {
  [pageNameKey]: {
    altText: "Destinatario",
  },
};

export const alarmProfileEmailRecipientsListNl = {
  [pageNameKey]: {
    altText: "Ontvanger",
  },
};

export const alarmProfileEmailRecipientsListTr = {
  [pageNameKey]: {
    altText: "Alıcı",
  },
};
